import React, { createContext, useEffect, useState } from 'react'
import Email from '../../main/FormFields/Email'
import { useHistory } from 'react-router-dom'
import { Spinner } from 'react-bootstrap'
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Form,
  FormGroup,
  FormText,
  Input,
  Row,
} from 'reactstrap'
import SetTitle from '../../utils/set_title'
import CharCheckModal from '../../components/molecules/CharCheckModal'
import { api } from '../../utils'
import { ToastContainer } from 'react-toastify'
import { notify } from '../../utils/notify'
import FileInput from '../../components/molecules/FileInput'
import ClienteSelect from '../../components/molecules/ClienteSelect'
import { useFileUpload } from '../../hooks'

const EmailContext = createContext()

const VolumeRetrieveForm = () => {
  SetTitle('Market Screener Report')
  const WORLDWIDE = 'Worldwide'
  const [locations, setLocations] = useState([])
  const [tables, setTables] = useState([])
  const [file, setFile] = useState(null)
  const [emails, setEmails] = useState([])
  const [province, setProvince] = useState('')
  const [validProvince, setValidProvince] = useState(null)
  const [name, setName] = useState('')
  const [clienti, setClienti] = useState([])
  const [selectedClientId, setSelectedClientId] = useState('')
  const { upload, loading } = useFileUpload()
  const [select, setSelect] = useState('standard')
  const [schedule, setSchedule] = useState(false)
  const [, setKeywords] = useState([])
  const [geoIndex, setGeoIndex] = useState(false)
  const [granularity, setGranularity] = useState('')
  const [historicalMonths, setHistoricalMonths] = useState(48)
  const [availableTargetTypes, setAvailableTargetTypes] = useState([])
  const [targetTypeCount, setTargetTypeCount] = useState(null)
  const [targetTypeCountLoading, setTargetTypeCountLoading] = useState(false)
  const [targetTypeCountError, setTargetTypeCountError] = useState(false)
  // Modal check caratteri
  const [showCharCheck, setShowCharCheck] = useState(false)
  const [errCharList, setErrCharList] = useState([])
  const [acceptedCharCheck, setAcceptedCharCheck] = useState(false)
  const [charCheckContext, setCharCheckContext] = useState(null)
  let history = useHistory()
  const [selectedLocations, setSelectedLocations] = useState([])

  const removeLocation = (locationToRemove) => {
    setSelectedLocations(selectedLocations.filter((location) => location !== locationToRemove))
  }

  const handleSubmit = async (event) => {
    if (event) event.preventDefault()
    if (selectedLocations.length === 0) {
      notify('Seleziona almeno una location.', 'error')
      return
    }
    let formData = new FormData()
    if (selectedLocations.length > 0) {
      formData.append('locations', selectedLocations.join(','))
    }
    if (province !== '') formData.append('province', province) //it will always be empty
    formData.append('emails', emails)
    formData.append('file', file)
    formData.append('select', select)
    formData.append('name', name)
    formData.append('schedule', schedule)
    formData.append('keyword_error_accepted', acceptedCharCheck)
    formData.append('geo_index', geoIndex)
    if (schedule) {
      formData.append('historical_months', historicalMonths)
    }
    if (!selectedClientId) {
      notify('Seleziona un cliente.', 'error')
      return
    }
    formData.append('cliente', selectedClientId)
    if (geoIndex) {
      formData.append('granularity', granularity)
    }

    let missingFields = []
    for (let key of formData.entries()) {
      if (key[1] == '' || key[1] == 'null' || key[1] == null || key[1] == 'null') {
        missingFields.push(key[0])
      }
    }
    if (missingFields.length > 0) {
      //altrimenti la stringa sfora le dimensioni del box
      let string = 'Campi mancanti: \n' + missingFields.toString().replaceAll(',', ',\n')
      notify(string, 'error')
      return
    }

    try {
      // TODO Should this be 'api/1/market-screener/' ?
      await upload('post', 'volume-api/1/market-screener/', formData, {
        onSuccess: (data) => {
          if (typeof data !== 'undefined') {
            notify('Report iniziato correttamente', 'success')
            setKeywords([])
            setFile(null)
            setSelect('standard')
            setSchedule(false)
            setAcceptedCharCheck(false)
            setGeoIndex(false)
            setGranularity('')
            setHistoricalMonths(48)
          } else {
            notify(
              'Richiesta fallita. Qualcosa è andato storto, riprovare o contattare un Innovation',
              'error'
            )
          }
        },
        onError: (errorMessage, err) => {
          if (err.response?.data?.message?.includes('ERROR Encoding keywords')) {
            setErrCharList(err.response.data?.errors)
            setCharCheckContext('submit')
            setShowCharCheck(true)
          } else {
            notify(err.response.data, 'error')
            setFile(null)
            setAcceptedCharCheck(false)
          }
        },
      })
    } catch (err) {
      console.error('Market Screener submission failed:', err)
    }
  }

  const checkProvince = (e) => {
    e.preventDefault()
    const province = e.target.value.trim()
    setValidProvince(null)
    if (province === '') return // Se la provincia è vuota è inutile controllare
    let formData = new FormData()
    formData.append('province', province)

    api
      .post('check-province/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        if (response.data === true) {
          setValidProvince(true)
          if (!selectedLocations.includes(province)) {
            setSelectedLocations([...selectedLocations, province])
            setProvince('')
          }
        } else setValidProvince(false)
      })
      .catch((err) => {
        setValidProvince(false)
      })
  }

  const confirmEvaluation = (e) => {
    e.preventDefault()
    setShowCharCheck(false)
    setAcceptedCharCheck(true)
  }

  const cancelEvaluation = () => {
    setShowCharCheck(false)
    setAcceptedCharCheck(false)
    setCharCheckContext(null)
  }

  useEffect(() => {
    if (acceptedCharCheck && charCheckContext === 'submit') {
      handleSubmit()
    }
  }, [acceptedCharCheck, charCheckContext])

  const handleFileSelection = (selectedFile) => {
    setFile(selectedFile)
    setAcceptedCharCheck(false)
    setCharCheckContext(null)
  }

  useEffect(() => {
    if (!geoIndex) {
      setGranularity('')
      setTargetTypeCount(null)
      setTargetTypeCountError(false)
    } else if (selectedLocations.length > 1) {
      setSelectedLocations([selectedLocations[0]])
    }
    if (geoIndex) {
      setSchedule(false)
      setProvince('')
      setValidProvince(null)
    }
  }, [geoIndex])

  useEffect(() => {
    api
      .get('clienti/')
      .then((res) => {
        setClienti(Array.isArray(res.data) ? res.data : res.data?.results || [])
      })
      .catch((err) => console.error(err))

    api
      .get('motori-ricerca/')
      .then((res) => {
        let locations = []
        try {
          for (let i = 0; i < res.data.length; i++) {
            locations.push(res.data[i].locale)
          }
        } catch {
          console.warn('Error while parsing locations')
        }
        locations.push(WORLDWIDE)
        locations = Array.from(new Set(locations))
        setLocations(locations)
      })
      .catch((err) => console.error(err))

    api
      .get('big-volume-tables/')
      .then((res) => {
        let tables = []
        try {
          for (let i = 0; i < res.data.length; i++) {
            tables.push(res.data[i].nome)
          }
        } catch {
          console.warn('Error while parsing locations')
        }
        setTables(tables)
      })
      .catch((err) => console.error(err))

    api
      .get('get-target-types/')
      .then((res) => {
        setAvailableTargetTypes(Array.isArray(res.data) ? res.data : [])
      })
      .catch((err) => console.error(err))
  }, [])

  const selectedCountryCode =
    selectedLocations
      .map((location) => {
        if (!location || !location.includes('-')) {
          return null
        }
        const parts = location.split('-')
        return parts[1] ? parts[1].toUpperCase() : null
      })
      .find((code) => code) || ''

  useEffect(() => {
    if (!geoIndex || !granularity || !selectedCountryCode) {
      setTargetTypeCount(null)
      setTargetTypeCountError(false)
      return
    }

    setTargetTypeCountLoading(true)
    setTargetTypeCountError(false)
    api
      .get('get-target-type-count/', {
        params: {
          country_code: selectedCountryCode,
          target_type: granularity,
        },
      })
      .then((res) => {
        const count = res?.data?.count
        setTargetTypeCount(Number.isFinite(count) ? count : null)
      })
      .catch(() => {
        setTargetTypeCount(null)
        setTargetTypeCountError(true)
      })
      .finally(() => {
        setTargetTypeCountLoading(false)
      })
  }, [geoIndex, granularity, selectedCountryCode])

  return (
    <>
      <div className="pb-5">
        <Card className="bg-secondary shadow">
          <CardHeader className="bg-white border-0">
            <Row style={{ marginLeft: '0px' }}>
              <Col md={10}>
                <h1 className="mb-0">Market Screener Report</h1>
              </Col>
              <Col md={2} style={{ textAlign: 'right' }}>
                <Button color="warning" onClick={() => history.push('market-screener')}>
                  &#60;- Go Back
                </Button>
              </Col>
            </Row>
          </CardHeader>
          <CardBody>
            <CharCheckModal
              show={showCharCheck}
              onHide={cancelEvaluation}
              onSubmit={confirmEvaluation}
              errCharList={errCharList}
              withExclusion={true}
            />
            {loading ? (
              <Spinner animation="grow" />
            ) : (
              <Form onSubmit={handleSubmit} id="idea-form" action="">
                <Row>
                  <Col md={6}>
                    <ClienteSelect
                      id="select-client"
                      label="Cliente"
                      clienti={clienti}
                      selectedClientId={selectedClientId}
                      onChange={setSelectedClientId}
                      isRequired
                      helpText="Associa il Market Screener al cliente."
                      showCreateLink
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <label htmlFor="name" style={{ display: 'block' }}>
                        Nome
                      </label>
                      <Input
                        className="form-control-alternative"
                        type="text"
                        placeholder="Inserisci nome report"
                        id="name"
                        onChange={(event) => {
                          if (tables.includes(event.target.value)) {
                            setTables(event.target.value)
                            setName('')
                            document.getElementById('name').value = ''
                          } else {
                            setName(event.target.value)
                            setTables('')
                          }
                        }}
                        onKeyDown={(event) =>
                          event.key === 'Enter' ? event.preventDefault() : null
                        }
                      />
                      <FormText color="muted" align={'left'}>
                        <b>
                          Il nome della tabella su BigQuery sarà uguale al nome specificato per il
                          report
                        </b>
                      </FormText>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <EmailContext.Provider value={{ emails, setEmails }}>
                        <Email context={EmailContext} />
                      </EmailContext.Provider>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <label htmlFor="location" style={{ display: 'block' }}>
                        Location
                      </label>
                      <Input
                        className="form-control-alternative"
                        type="select"
                        id="location"
                        value={''}
                        onChange={(event) => {
                          if (geoIndex) {
                            setSelectedLocations([event.target.value])
                          } else if (!selectedLocations.includes(event.target.value)) {
                            setSelectedLocations([...selectedLocations, event.target.value])
                          }
                        }}
                      >
                        <option value="" disabled hidden>
                          Seleziona location
                        </option>
                        {locations.map((location, index) => (
                          <option key={index} value={location}>
                            {location}
                          </option>
                        ))}
                      </Input>
                      <div style={{ marginTop: '10px' }}>
                        {selectedLocations.map((location, index) => (
                          <Button
                            key={index}
                            style={{
                              marginRight: '5px',
                              marginBottom: '5px',
                              borderRadius: '30px',
                              padding: '5px 10px',
                            }}
                            onClick={() => removeLocation(location)}
                            color="info"
                          >
                            {location} &times;
                          </Button>
                        ))}
                      </div>
                      <FormText color="muted" align={'left'}>
                        Se vengono selezionate più località, verrà generato un unico report che
                        include tutte le località selezionate.
                        <br />
                      </FormText>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <label htmlFor="geoIndex">Geo Index</label>
                      <Input
                        id="geoIndex"
                        type="checkbox"
                        checked={geoIndex}
                        style={{ width: 'auto', marginLeft: '0px' }}
                        onChange={() => setGeoIndex(!geoIndex)}
                      />
                      <FormText color="muted" style={{ marginLeft: '20px' }}>
                        Se attivo, il report includerà <b>tutte</b> le località del paese
                        selezionato. (
                        <span style={{ color: 'red' }}>
                          ATTENZIONE: questo potrebbe richiedere molto tempo per essere generato.
                          Usare solo se necessario.
                        </span>
                        )
                      </FormText>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <FileInput
                      onFileChange={handleFileSelection}
                      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      helpText={
                        <>
                          Carica un file contenente le tue keywords. <br />
                          <b>Il file deve contenere almeno una colonna "Keyword"</b>
                          <br />
                          <b>
                            Le singole keyword non devono contenere questi simboli: @ \ ^ = ! `{' '}
                            {'<'} {'>'} {'['} {']'} {'('} {')'} % | ? ; ~
                          </b>
                        </>
                      }
                      required={true}
                    />
                  </Col>
                </Row>
                <br></br>
                <Row>
                  <Col md={6}>
                    {!geoIndex ? (
                      <FormGroup>
                        <label htmlFor="province" style={{ display: 'block' }}>
                          Province
                        </label>
                        <Input
                          className="form-control-alternative"
                          id="province"
                          type="text"
                          style={{ height: '44px' }}
                          value={province}
                          onChange={(event) => {
                            setProvince(event.target.value)
                          }}
                          onBlur={(event) => checkProvince(event)}
                          onKeyDown={(event) =>
                            event.key === 'Enter' ? event.preventDefault() : null
                          }
                        />
                        <FormText color="muted" align={'left'}>
                          {validProvince === true && (
                            <b style={{ color: 'green' }}>
                              La provincia è valida e aggiunta all'elenco
                              <br />
                            </b>
                          )}
                          {validProvince === false && (
                            <b style={{ color: 'red' }}>
                              La provincia non è valida
                              <br />
                            </b>
                          )}
                          <strong>Campo opzionale</strong>, consente di richiedere i volumi di una
                          specifica provincia. Inserire il nome della provincia per esteso (Es.
                          "Correggio")
                          <br />
                        </FormText>
                      </FormGroup>
                    ) : (
                      <FormGroup>
                        <label htmlFor="granularity" style={{ display: 'block' }}>
                          Granularità
                        </label>
                        <Input
                          className="form-control-alternative"
                          type="select"
                          id="granularity"
                          value={granularity}
                          onChange={(event) => setGranularity(event.target.value)}
                          required={geoIndex}
                        >
                          <option value="" disabled hidden>
                            Seleziona granularità
                          </option>
                          {availableTargetTypes.map((targetType) => (
                            <option key={targetType} value={targetType}>
                              {targetType}
                            </option>
                          ))}
                        </Input>
                        <FormText color="muted">
                          Country Code: <b>{selectedCountryCode || '-'}</b>
                          <br />
                          {granularity && (
                            <>
                              {targetTypeCountLoading && (
                                <span>Calcolo delle location in corso...</span>
                              )}
                              {!targetTypeCountLoading && targetTypeCountError && (
                                <span>Impossibile calcolare le location.</span>
                              )}
                              {!targetTypeCountLoading &&
                                !targetTypeCountError &&
                                Number.isFinite(targetTypeCount) && (
                                  <span>
                                    {targetTypeCount === 1
                                      ? 'Verrà processata 1 località'
                                      : targetTypeCount === 0
                                      ? 'Nessuna località trovata per questa granularità.'
                                      : `Verranno processate ${targetTypeCount} località.`}
                                  </span>
                                )}
                            </>
                          )}
                        </FormText>
                      </FormGroup>
                    )}
                  </Col>
                  <Col md={6}>
                    {!geoIndex && (
                      <FormGroup>
                        <label htmlFor="schedule">Monthly update</label>
                        <Input
                          id="schedule"
                          type="checkbox"
                          checked={schedule}
                          style={{ width: 'auto', marginLeft: '0px' }}
                          onChange={() => setSchedule(!schedule)}
                        />
                        <FormText color="muted" style={{ marginLeft: '20px' }}>
                          Se attivo, <b>la tabella di BigQuery verrà aggiornata mensilmente</b>{' '}
                          tramite API Google Ads. Alla prima attivazione parte subito anche il
                          recupero dei mesi storici già disponibili.
                        </FormText>
                      </FormGroup>
                    )}
                  </Col>
                </Row>
                {schedule && !geoIndex && (
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <label htmlFor="historicalMonths" style={{ display: 'block' }}>
                          Historical months
                        </label>
                        <Input
                          className="form-control-alternative"
                          type="number"
                          id="historicalMonths"
                          min="1"
                          max="48"
                          value={historicalMonths}
                          onChange={(event) => setHistoricalMonths(event.target.value)}
                        />
                        <FormText color="muted" align={'left'}>
                          Numero di mesi passati da preparare quando attivi il report mensile.
                          Default: <b>48</b>.
                        </FormText>
                      </FormGroup>
                    </Col>
                  </Row>
                )}
                <Row style={{ display: 'flex', justifyContent: 'flex-end', marginRight: '50px' }}>
                  <Button color="info" size="lg" type="submit">
                    Submit Report
                  </Button>
                </Row>
              </Form>
            )}
            <ToastContainer />
          </CardBody>
        </Card>
      </div>
    </>
  )
}
export default VolumeRetrieveForm
